import {
  AsyncActionState,
  IAsyncAction,
  IAsyncFetchableAction,
  IAsyncErrorAction,
} from '@telstra-connect/standard-actions/async-action'
import {SERVICE_PERFORMANCE_LOAD_SITES_MAP_DATA} from './action-types'
import {
  ISitesMapDataResponse,
  ISiteCompanyFilterInternational,
  ISitesMapDataResponseInt,
} from '../state/sites-map-data'
import {INVENTORY_INTERNATIONAL_UPDATE_SEARCH_SITES} from '../actions/action-types'

export interface ILoadSitesMapDataAction
  extends IAsyncFetchableAction<typeof SERVICE_PERFORMANCE_LOAD_SITES_MAP_DATA> {}

export interface ILoadSitesMapDataSuccessAction
  extends IAsyncAction<typeof SERVICE_PERFORMANCE_LOAD_SITES_MAP_DATA> {
  data: ISitesMapDataResponse
}

export interface ILoadSitesMapDataSuccessActionInt
  extends IAsyncAction<typeof SERVICE_PERFORMANCE_LOAD_SITES_MAP_DATA> {
  data: ISitesMapDataResponseInt
}

export type ILoadSitesMapDataErrorAction = IAsyncErrorAction<
  typeof SERVICE_PERFORMANCE_LOAD_SITES_MAP_DATA
>

export const loadSitesMapdataStart = (): ILoadSitesMapDataAction => ({
  status: AsyncActionState.Initiated,
  type: SERVICE_PERFORMANCE_LOAD_SITES_MAP_DATA,
  isFetchable: true,
})

export const loadSitesMapDataSuccess = (
  data: ISitesMapDataResponse,
): ILoadSitesMapDataSuccessAction => ({
  status: AsyncActionState.Success,
  type: SERVICE_PERFORMANCE_LOAD_SITES_MAP_DATA,
  data,
})

export const loadSitesMapDataSuccessInt = (
  data: ISitesMapDataResponseInt,
): ILoadSitesMapDataSuccessActionInt => ({
  status: AsyncActionState.Success,
  type: SERVICE_PERFORMANCE_LOAD_SITES_MAP_DATA,
  data,
})

export const loadSitesMapDataError = (error: string): ILoadSitesMapDataErrorAction => ({
  status: AsyncActionState.Failure,
  type: SERVICE_PERFORMANCE_LOAD_SITES_MAP_DATA,
  error,
})

export interface IUpdateSitesCompaniesFilterSuccessActionInt {
  type: string
  data: ISiteCompanyFilterInternational
}

export const updateCompaniesFilterSuccessInt = (
  data?: ISiteCompanyFilterInternational,
): IUpdateSitesCompaniesFilterSuccessActionInt => ({
  type: INVENTORY_INTERNATIONAL_UPDATE_SEARCH_SITES,
  data,
})
